import {
  HousingApplicationDto,
  HousingSiteResultType,
  HousingIntakeScenario,
  HousingIntakeScenarioDto,
  HousingApplication,
  HousingSiteResult,
} from "~/api";

import { useHousingSiteStore } from "~/YYC_Housing/stores/HousingSiteStore";

/**
 * Form code of the PRS workflow-step form. Form codes are admin-editable in
 * the form designer and matched case-insensitively (see housingModuleCodes in
 * FormPropertiesEditor.vue).
 */
export const PRS_FORM_CODE = "PRS";

export const formatApplyingForAndHMB = (
  housingApplication: HousingApplicationDto | HousingApplication,
) => {
  let eligibleCount = 0;
  let selectedCount = 0;
  let applyingForSummary = "";
  let hmbSummary = "";

  const counter: Record<string, number> = {};
  const seenSites = new Set<string>();

  housingApplication.siteResults?.forEach((siteResult: HousingSiteResult) => {
    if (siteResult.resultType !== HousingSiteResultType.PREFERRED) return;
    const siteKey = `${siteResult.hmb}|${siteResult.siteCode}`;
    if (seenSites.has(siteKey)) return;
    seenSites.add(siteKey);

    if (siteResult.hmb in counter) {
      counter[siteResult.hmb]++;
    } else {
      counter[siteResult.hmb] = 1;
    }
    selectedCount++;
  });
  const finderInput =
    "finderInput" in housingApplication
      ? housingApplication.finderInput
      : undefined;
  eligibleCount = finderInput?.totalEligibleSites ?? selectedCount;

  if (Object.keys(counter).length === 0) {
    hmbSummary = "-";
  } else {
    hmbSummary = Object.entries(counter)
      .map(([key, count]) => `${key} (${count})`)
      .join(", ");
  }

  applyingForSummary = `Selected (${selectedCount}/${eligibleCount})`;

  return { hmbSummary, applyingForSummary };
};

export function formatIntakeScenarioName(
  scenario: HousingIntakeScenario | HousingIntakeScenarioDto | undefined,
): string {
  if (!scenario?.housingSiteGuid) {
    return "Unknown";
  }

  const housingSiteStore = useHousingSiteStore();
  // Pull a representative unit number from the first vacancy's UnitNumbers list,
  // falling back to the scenario-level effectiveUnitNumber.
  const full = scenario as Partial<HousingIntakeScenario> &
    Partial<HousingIntakeScenarioDto>;
  const firstVacancy = full.vacancies?.[0];
  const unitLabel =
    firstVacancy?.unitNumbers?.[0] ?? full.effectiveUnitNumber ?? "";
  return `${housingSiteStore.getNameByGuid(scenario.housingSiteGuid)}${unitLabel ? ` - ${unitLabel}` : ""}`;
}

export const contactHistoryActivityTypeOptions = [
  { label: "📝 Notes", value: "Notes" },
  { label: "📝 Notes - Legacy", value: "Legacy" },
  { label: "📞 Phone Call", value: "PhoneCall" },
  { label: "📧 Email", value: "Email" },
  { label: "💬 Messaging", value: "Messaging" },
  { label: "🤝 Meeting", value: "MeetingActivity" },
  { label: "📋 Task", value: "TaskActivity" },
  { label: "⚠️ On Hold Task", value: "On Hold Task" },
  { label: "🛑 Cancellation", value: "Cancellation" },
  { label: "↩️ Move Back to Review", value: "MoveBackToReview" },
  { label: "🏠 Offer", value: "Offer" },
  { label: "🚫 No Offer", value: "NoOffer" },
  { label: "🔄 Cancel No Offer", value: "CancelNoOffer" },
  { label: "❌ Strike", value: "Strike" },
  { label: "🚨 Three Strikes", value: "ThreeStrikes" },
];
